import React, { useEffect, useState } from 'react';
import { ToastMessage } from 'src/context/toastMessageContext';
import { Alert, Box } from '@cloudscape-design/components';

export const Toast = ({
  header,
  description,
  type = 'info',
  dismissTime,
  onDismiss,
}: ToastMessage) => {
  const [visible, setVisible] = useState(true);
  const [held, setHeld] = useState(false);

  useEffect(() => {
    if (held) return;
    const timer = setTimeout(() => {
      setVisible(false);
      onDismiss?.();
    }, dismissTime ?? 7000);

    return () => clearTimeout(timer);
  }, [held]);

  if (!visible) {
    return <></>;
  }

  return (
    <div
      onMouseEnter={() => {
        setHeld(true);
      }}
    >
      <Alert
        type={type}
        header={header}
        dismissible={true}
        onDismiss={() => {
          onDismiss?.();
          setVisible(false);
        }}
      >
        <Box margin={{ bottom: 'm' }}>{description}</Box>
        {!held ? (
          <div
            style={{
              animation: `expand ${dismissTime ? Math.floor(dismissTime / 1000) : 7}s ease-out`,
            }}
            className={`toast-message__progress-bar toast-message__progress-bar--${type}`}
          />
        ) : (
          <div className="toast-message__progress-bar" />
        )}
      </Alert>
    </div>
  );
};
